import { ContractRevenueItem, ScheduledPayment } from "@/pages/contracts/types";
import { CreateRevenueItemRequest } from "@/pages/contracts/hooks";
import { toApiDateOrNull } from "./components/termsDraft/apiDates";

// The drawer submits calendar days; the rows it edits carry the API's
// midnight-UTC form. Without this a line round-tripped through the drawer
// unchanged still differs from its baseline on every date it holds.
export const requestDates = (request: CreateRevenueItemRequest) => ({
  serviceStartDate: toApiDateOrNull(request.serviceStartDate),
  serviceEndDate: toApiDateOrNull(request.serviceEndDate),
  billingStartDate: toApiDateOrNull(request.billingStartDate),
  billingEndDate: toApiDateOrNull(request.billingEndDate),
  customOptOutDate: toApiDateOrNull(request.customOptOutDate)
});

// The drawer submits the input shape; rows keep the read shape.
export const requestScheduledPayments = (
  request: CreateRevenueItemRequest,
  revenueItemId: string
): ScheduledPayment[] =>
  request.scheduledPayments.map(
    (payment) =>
      ({
        id: `${revenueItemId}-${payment.paymentNumber}`,
        revenueItemId,
        paymentNumber: payment.paymentNumber,
        billingDate: payment.billingDate,
        amount: payment.amount,
        percentage: payment.percentage,
        createdAt: new Date().toISOString(),
        isDeleted: false
      }) as unknown as ScheduledPayment
  );

// Requests carry plain ISO strings; the cast bridges the ISOStringFormat template type.
export const requestToRevenueItem = (
  request: CreateRevenueItemRequest,
  id: string,
  contractId: string
): ContractRevenueItem =>
  ({
    ...request,
    ...requestDates(request),
    id,
    contractId,
    total: request.total ?? null,
    totalLocal: request.totalLocal ?? null,
    customDuration: null,
    // Server-derived from the dates; unknown until the row is saved.
    status: null,
    durationDisplay: null,
    createdAt: new Date().toISOString(),
    isDeleted: false,
    scheduledPayments: requestScheduledPayments(request, id),
    itemOrder: null,
    periodIndex: null,
    previousPeriods: [],
    // Authorship is server-set; unknown until the row is saved.
    note: request.note ?? null,
    noteUpdatedBy: null,
    noteUpdatedAt: null
  }) as unknown as ContractRevenueItem;
